<template>
  <div>
    <Row>
      <Form ref="querycustomsForm" :model="query" :label-width="100"  label-position="right" inline class="index-query-form">
        <Form-item label="箱号" prop="xh">
          <Input v-model="query.xh" />
        </Form-item>
        <Form-item :label="this.$t('custom.type.type.dictionary.label')" prop="type">
          <Select v-model="query.type" clearable filterable style="width: 120px">
            <Option v-for="item in dict.type" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
          </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="attendanceManagerTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
  </div>
</template>
<script type="text/jsx">
import dict from '@/components/dict'
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'


export default {
  name: 'aip-screen-customsContainer-index',
  mixins:[mixin],
  dictParams: ['type'],
    components: {
      'dict-tag': dict
    },
  data () {
    return {

      query:{
          xh:undefined,
          type: '',
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      options1:[],
      customContainerDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  created () {
  },
  methods: {

    handleSearch(){
      this.page.loading = true;
      api.screen.customsContainer.query(this.query,this.page)
        .then(data=>{
          console.log(data);
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },

  },
  computed: {
    columns () {
      return [

        {key: 'xh', align:'center',minWidth: 120, title: '箱号'},
        {key: 'kzbz', align:'center',minWidth: 120, title: '空重标志'},
        {key: 'xx', align:'center',minWidth: 120, title: '箱型'},
        {key: 'wz', align:'center',minWidth: 120, title: '位置'},
        {key: 'xsmc', align:'center',minWidth: 120, title: '箱属名称'},
        {key: 'xlmc', align:'center',minWidth: 120, title: '箱类名称'},
          {
            key: 'type',
            align: 'center',
            width: 120,

            column:'type',
            filters: this.$t('custom.type.type.dictionary'),
            filterMultiple: false,

            filterRemote:(value,row)=>{
              this.query.type = value
              this.handleSearch();
            },
            title: this.$t('custom.type.type.dictionary.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.type==t.value).label}</div>
            }
          }
      ]
    }
  }
}
</script>
